import { TprmRequirementType } from '../entity-details';

import { AssignmentRule } from './AssignmentRule.model';

export enum RiskProfileType {
    default = 'DEFAULT',
    collateral = 'COLLATERAL',
}

export interface RiskProfileInput {
    displayName: string;
    active: boolean;
    ccgType: RiskProfileType;
    numberOfCoverageTypes: number | null;
    numberOfInsuredsAssigned: number | null;
    // Undefined represents when none of options has been selected as assignment option
    assignmentRule: AssignmentRule | null;
    assignedEntityInfo: { displayName: string, email: string } | null;
    countryCode: string | null;
    evaluationRule?: {
        coverageTypes: TprmRequirementType[];
    };
}

export interface RiskProfile extends RiskProfileInput {
    id: string;
    countryCode: string;
}
